import ACLGuard from "components/ACL/ACLGuard"
import { defaultPermission, Permission } from "components/ACL/RoleEnum"
import AppContext, { AppContextProps } from "containers/context/Context"
import { useGetCurrentUserRoleIdLazyQuery, useGetPermissionKeyByRoleIdLazyQuery } from "generated/graphql"
import { useAccessControl } from "helpers/permissionHelper"
import { useContext } from "react"

const flattenToStrings = (input: any): string[] => {
    const result: string[] = [];

    const recurse = (input: any) => {
        if(typeof input === 'string') {
            result.push(input)
        } else if (Array.isArray(input)) {
            input.forEach(recurse)
        } else if(typeof input === 'object' && input !== null) {
            Object.values(input).forEach(recurse)
        }
    }

    recurse(input)
    return result;
}

const useACL = () => {
    const context = useContext<AppContextProps>(AppContext);
    const { rootState, rootDispatch } = context;

    const isPermit = (permission: string | string[]) => {
        return useAccessControl(permission, context)
    }

    // get current user role id
    const [refetchPermissionKeyWithCurrentRoleId] = useGetCurrentUserRoleIdLazyQuery({
        onCompleted: ({getUserRole: userRoleId}) => {
            if(rootState.userInfo.roleId !== userRoleId ) {
                getPermissionKey({
                    variables: {
                        roleId: userRoleId
                    },
                })
            
                rootDispatch({
                    type: 'userInfo',
                    payload: {
                        ...rootState.userInfo,
                        roleId: userRoleId
                    }
                })
            }
        }
    });
    
    // Get permission role key based on roleId
    const [getPermissionKey] = useGetPermissionKeyByRoleIdLazyQuery({
        onCompleted:(({getPermissionKeyByRoleId: permissionKeys}) => {
            rootDispatch({
                type: 'userInfo',
                payload: {
                    ...rootState.userInfo,
                    permissionKeys: [...defaultPermission, ...permissionKeys]
                }
            })
        })
    })
    

    return {
        ACLGuard,
        isPermit,
        Permission,
        convertPermissionKeyEnum: flattenToStrings,
        refetchPermissionKeyWithCurrentRoleId: !rootState?.userInfo?.superUser ? refetchPermissionKeyWithCurrentRoleId : () => null
    }
}

export default useACL